<mat-card style="text-align: center">

  <h3>Activate Two-Factor Authentication</h3>

  <ng-container *ngIf="alreadyActive">
    <div>
      <mat-icon style="color: forestgreen; font-size: 1em; margin: 0; padding: 0; height: auto; width: auto;">security</mat-icon> You have already activated Two-Factor Authentication.
    </div>

    <br /><br />
    <button mat-raised-button color="primary" (click)="returnBack()" type="button">Go back</button>

  </ng-container>


  <ng-container *ngIf="!alreadyActive">

    <div>You need the Google Authenticator or another compatible app on your smartphone</div>

    <div style="display: inline-block; margin: 20px 10px;">
      <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">
        <img alt="apple app store link" src="assets/img/app-store-badge.png" height="50" />
      </a>
    </div>
    <div style="display: inline-block; margin: 20px 10px;">
      <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">
        <img alt="google play store link" src="assets/img/google-play-badge.png" height="50" />
      </a>
    </div>

    <div>

      <div style="text-align: left; display:inline-block">
        <ul>
          <li>The QR code may only be used once for the set-up of your authenticator app</li>
          <li>The QR code may never be stored or shared with others</li>
          <li>If you change phones or authentication apps, be sure to transfer your accounts</li>
        </ul>
      </div>

      <div>
        <mat-checkbox [disabled]="showQrCode" [(ngModel)]="qrTosChecked" matInput labelPosition="after" [ngModelOptions]="{standalone: true}">
          I acknowledge the terms above.
        </mat-checkbox>

      </div>
      <br />
      <button [class.spinner]="isLoadingQrCode" mat-raised-button color="primary" style="margin-right: 10px;" [disabled]="isLoadingQrCode || !qrTosChecked || showQrCode" (click)="activateTotp()">Display a QR Code for setup</button>
    </div>
    <br />
    <br />

    <ng-container *ngIf="showQrCode">
      <div style="display: inline-block">

        <img [src]="qrUrlSafe" style="width: 300px; height:auto;" />

        <form [formGroup]="totpForm" (submit)="submit()">
          <mat-card>
            <mat-card-header>
              <mat-card-title>
                Confirm Two-Factor authentication
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-form-field>
                <input matInput type="text" placeholder="Authentication code" formControlName="totp" required>
              </mat-form-field>
            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button color="accent" (click)="returnBack()" type="button">Cancel</button>
              <button mat-raised-button color="primary" [disabled]="!totpForm.valid" type="submit">Confirm</button>
            </mat-card-actions>
          </mat-card>
        </form>
      </div>
    </ng-container>
  </ng-container>


</mat-card>
